import React, { useEffect, useState } from "react";
import AppreciateYouComponent from "../../components/appreciateYou";
import { useAppDispatch } from "../../hooks/reduxHooks";
import { getSkinProfileApi } from "../../services/skinProfile.service";

interface AppreciateYouContainerInterface { }

const AppreciateYouContainer: React.FC<
  AppreciateYouContainerInterface
> = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState();

  const dispatch = useAppDispatch();

  const fetchAppriciation = () => {
    setLoading(true);
    dispatch(
      getSkinProfileApi({
        finalCallback: () => {
          setLoading(false);
        },
        successCallback: (data: any) => {
          setData(data?.response?.appreciation_message);
        },
        unAunthicatedCallback: () => {

        }
      })
    );
  };

  useEffect(() => {
    fetchAppriciation();
  }, []);
  return <AppreciateYouComponent data={data} />;
};

export default AppreciateYouContainer;
